export const creaOpciones = (arbol, cbEtiqueta = x => x.nombre) => {
  const opcionesJerarquicas = ({nivel, lista}, objeto) => {
    const hijos = objeto.hijos.reduce(opcionesJerarquicas, {
      nivel: nivel + 1,
      lista: []
    }).lista;

    const etiqueta = [...Array(nivel)].map(x => '–').join('') + ' ' + cbEtiqueta(objeto);

    return {
      nivel,
      lista: [
        ...lista,
        {valor: objeto.id, etiqueta},
        ...hijos
      ]
    };
  };

  return arbol.reduce(opcionesJerarquicas, {nivel: 0, lista: []}).lista;
}